<template>
  <div class="wrapper" id="mapDiv" style="height: 100%; width: 100%">
    <GmapMap
      ref="mapRef"
      :center="center"
      :zoom="11.5"
      class="mapCircle"
      style="height: 100%; width: 100%"
      :options="{
        zoomControl: false,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      }"
    >
      <GmapMarker
        :key="index"
        v-for="(m, index) in mapMarkers"
        :position="m.position"
        :clickable="true"
        @click="goToCenter(m.position)"
        :draggable="enableDragToUpdate"
        :icon="m.icon"
        :zIndex="12"
        @dragend="markerMoved(m, $event.latLng)"
      />
    </GmapMap>
    <i class="top"></i>
    <i class="right"></i>
    <i class="bottom"></i>
    <i class="left"></i>
    <i class="top left"></i>
    <i class="top right"></i>
    <i class="bottom left"></i>
    <i class="bottom right"></i>
  </div>
</template>

<script>
import TaxiMapStateSummary from "@/components/overwatch/TaxiMapStateSummary.vue";
import { gmapApi } from "vue2-google-maps";

import { Overwatch } from "@/components/util/Overwatch.js";

import createCustomerMapMarker from "@/components/util/CustomerMapMarker.js";
import createHTMLMapMarker from "@/components/util/HTMLMarker.js";
import { setTimeout } from "timers";

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "DriversMapMarkers",
  components: {
  },
  props: {
    height: {
      type: Number,
      default: 500,
    },
    drivers: Array,
    bookings: Array,
    setSelectedTaxi: Function,
    showStateSummary: {
      type: Boolean,
      default: true,
    },
    enableDragToUpdate: {
      type: Boolean,
      default: false,
    },
    customersForMap: {
      type: Array,
      default: () => [],
    },
    showCustomersInApp: {
      type: Boolean,
      default: false,
    },
    navigateToTaxiId: {
      type: Number,
      default: null,
    },
    zone: Object
  },
  data: function () {
    return {
      markers: [],
      mapMarkers: [],
      center: this.$store.state.center,
      panned: false,
      token: "",
      map: null,
      polyline: null,
      driverTracePolylines: [],
      geocoder: null,
      zonePolygon: null
    };
  },
  watch:  {
    zone: function() {
      if (this.zone == undefined || this.zone == null) {
        return;
      }
      
      this.showZone(this.zone);
    },
    drivers () {
      this.updateMarkers(null)
    }
  },
  mounted: function () {
    // this.recenter()
    console.log("MAP CENTER " + JSON.stringify(this.center));
    
    var vm = this;
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
      this.recenter()
      
      var trafficLayer = new google.maps.TrafficLayer();
      trafficLayer.setMap(map);
      
      this.updateMarkers(-1);
      
      var geocoder = new google.maps.Geocoder();
      this.geocoder = geocoder;
      
      console.log(geocoder);
    });
  },
  computed: {
    google: gmapApi,
    availabilityCenter () {
      return this.$store.getters['availabilityRegion/getCenter']
    },
    mapCenter () {
      if (this.availabilityCenter) {
        return {
          lat: this.availabilityCenter.center_location.lat,
          lng: this.availabilityCenter.center_location.lon,
        }
      } else {
        return this.center
      }
    }
  },
  methods: {
    markerMoved: function (marker, location) {
      console.log("MARKER MOVED");
      
      var vm = this;
      
      try {
        if (marker.location.custom == true) {
          console.log("CUSTOM LOCATION SO NOT DOING ANYTHING");
          
          marker.location.latLng.latitude = location.lat();
          marker.location.latLng.longitude = location.lng();
          
          marker.location.invalid = true;
          marker.location.custom = true;
          
          vm.$emit("placechanged");
        } else {
          console.log("Reverse Geocoding");
          
          this.geocoder.geocode({ location: location }, function (
            results,
            status
          ) {
            if (status === "OK") {
              console.log(results);
              
              let addressComponents = {
                street_number: "short_name",
                route: "long_name",
                locality: "long_name",
                administrative_area_level_1: "short_name",
                country: "long_name",
                postal_code: "short_name",
              };
              let returnData = {};
              
              var place = results[0];
              
              if (place.address_components !== undefined) {
                // Get each component of the address from the place details
                for (let i = 0; i < place.address_components.length; i++) {
                  let addressType = place.address_components[i].types[0];
                  if (addressComponents[addressType] != undefined) {
                    let val =
                      place.address_components[i][
                        addressComponents[addressType]
                        ];
                    returnData[addressType] = val;
                  }
                }
                
                returnData["latitude"] = place.geometry.location.lat();
                returnData["longitude"] = place.geometry.location.lng();
                // return returnData object and PlaceResult object
                
                var address = place.formatted_address;
                
                if (
                  place.types.includes("establishment") &&
                  place.name != "undefined" &&
                  place.name != undefined &&
                  place.name != null
                ) {
                  // console.log("PLACE NAME " + place.name);
                  address = place.name + ", " + address;
                }
                
                marker.location.description = address;
                
                vm.sendLocationToServer(
                  place.geometry.location.lat(),
                  place.geometry.location.lng(),
                  address,
                  function (loc) {
                    marker.location.id = loc.id;
                    vm.$emit("placechanged");
                  }
                );
              }
            } else {
              window.alert("Geocoder failed due to: " + status);
            }
          });
        }
      } catch (e) {
        print(e);
      }
    },
    sendLocationToServer(latitude, longitude, description, success) {
      axios({
        url: `${this.$store.state.apiUrl}/location/add`,
        method: "POST",
        params: {
          lat: latitude,
          lon: longitude,
          description: description,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(function (res) {
          // console.log(res.data);
          var loc = {
            id: res.data.id,
            description: res.data.description,
            latLng: {
              latitude: res.data.lat,
              longitude: res.data.lon,
            },
          };
          
          success(loc);
        })
        .catch((err) => console.error(err));
    },
    goToCenter: function (p) {
      this.map.setCenter(p);
      this.map.setZoom(12.5);
    },
    recenter: function () {
      this.map.setCenter(this.mapCenter);
      this.map.setZoom(11.5);
    },
    clear: function () {
      
      console.log("Clearing Overwatch Map");
      
      if (this.polyline != null) {
        this.polyline.setMap(null);
      }
      
      if (this.zonePolygon != null) {
        this.zonePolygon.setMap(null);
        console.log("Removed Polygon");
      }
      
      this.mapMarkers = [];
    },
    zoomToMakingBooking: function (job) {
      console.log("Zoom to making booking");
      
      if (this.polyline != null) {
        this.polyline.setMap(null);
      }
      
      var bounds = new google.maps.LatLngBounds();
      
      this.mapMarkers = [];
      
      if (job.pickup_location.latLng != null) {
        this.mapMarkers.push({
          location: job.pickup_location,
          position: {
            lat: job.pickup_location.latLng.latitude,
            lng: job.pickup_location.latLng.longitude,
          },
          icon: {
            url: "/img/map/pickup_marker.png",
            anchor: new google.maps.Point(13, 32),
          },
          zIndex: 12,
        });
      }
      
      bounds.extend({
        lat: job.pickup_location.latLng.latitude,
        lng: job.pickup_location.latLng.longitude,
      });
      
      if (job.destinations != null && job.destinations.length > 0) {
        if (job.destinations[0].latLng != null) {
          this.mapMarkers.push({
            location: job.destinations[0],
            position: {
              lat: job.destinations[0].latLng.latitude,
              lng: job.destinations[0].latLng.longitude,
            },
            icon: {
              url: "/img/map/destination_marker.png",
              anchor: new google.maps.Point(13, 32),
            },
            zIndex: 12,
          });
          
          bounds.extend({
            lat: job.destinations[0].latLng.latitude,
            lng: job.destinations[0].latLng.longitude,
          });
        }
        
        for (var i = 1; i < job.destinations.length; i++) {
          if (job.destinations[i].latLng != null) {
            this.mapMarkers.push({
              location: job.destinations[i],
              position: {
                lat: job.destinations[i].latLng.latitude,
                lng: job.destinations[i].latLng.longitude,
              },
              icon: {
                url: "/img/map/via_marker.png",
                anchor: new google.maps.Point(13, 32),
              },
              zIndex: 12,
            });
            
            bounds.extend({
              lat: job.destinations[i].latLng.latitude,
              lng: job.destinations[i].latLng.longitude,
            });
          }
        }
      }
      
      this.showZone();
      
      this.map.fitBounds(bounds, 70);
      
      if (this.mapMarkers.length == 1) {
        this.map.setZoom(12.5);
      }
    },
    showZone: function(zone) {
      
      if (this.zonePolygon != null) {
        this.zonePolygon.setMap(null);
      }
      
      if (zone == null) {
        return;
      }
      
      var polygonCoords = [];
      var polygonJSON = this.zone.area;
      
      for (var i = 0; i < polygonJSON.length; i++) {
        polygonCoords.push({
          lat: polygonJSON[i][0],
          lng: polygonJSON[i][1]
        });
      }
      
      this.zonePolygon =
        this.addPolygon(polygonCoords, "#fefefe", this.zone.name)
    },
    updateMarkers: function (selectedTaxi) {
      console.log(this.markers.length);
      console.log('updating markers')
      this.markers.map(function (m) {
        m.remove();
      });
      this.markers.length = 0;
      if (this.drivers != null) {
        console.log('drivers length not null ' + this.drivers.length )
        for (var i = 0; i < this.drivers.length; i++) {
          var driver = this.drivers[i];
          this.addDriverMarker(driver, selectedTaxi);
        }
      }
    },
    zoomToTaxi: function (selectedTaxi) {
      if (this.polyline != null) {
        this.polyline.setMap(null);
      }
    
      this.mapMarkers = [];
      this.mapMarkers = this.mapMarkers;
    
      var taxi = this.drivers.find(function (t) {
        return t.id == selectedTaxi;
      });
    
      if (taxi == null) {
        this.recenter();
        return;
      }
      
      if (!taxi.lat && !taxi.lng ) {
        this.$snackbar.show('Driver post code is not valid')
        this.recenter();
        return;
      }
    
      this.zoomToBookingTaxi(taxi);
    },
    zoomToBookingTaxi: function (taxi) {
      var bounds = new google.maps.LatLngBounds();
  
      this.map.setCenter({
        lat: taxi.lat,
        lng: taxi.lng,
      });
    
      this.map.setZoom(15.0);
      // if (taxi != null) {
      //   bounds.extend({
      //     lat: taxi.lat,
      //     lng: taxi.lng,
      //   });
      // }
      // this.map.fitBounds(bounds,70);
    },
    addDriverMarker: function (driver, selectedTaxi) {
      if (driver.lat && driver.lng) {
        var latLng = new google.maps.LatLng(driver.lat, driver.lng);
  
  
        var setSelectedTaxi = this.setSelectedTaxi;
        let marker = createHTMLMapMarker({
          latlng: latLng,
          map: this.map,
          html: `<p style="text-align: center; font-weight: 600">${driver.callsign}</p>`,
          color: '#727475',
          click: function () {
            setSelectedTaxi(driver.id);
          },
          selected: selectedTaxi == driver.id,
          fade: false,
          zIndex: 4
        });
        console.log('marker ', marker)
        this.markers.push(marker);
      }
    },
    zIndexForTaxi(taxi, ow) {
      
      var categoryForTaxi = ow.categoryForTaxi(taxi);
      
      if (categoryForTaxi == 'available') {
        return 5;
      }
      
      if (categoryForTaxi == 'running_late') {
        return 4;
      }
      
      return 3;
    },
    addPolygon: function(coords, color, name) {
      var polygon = new google.maps.Polygon({
        paths: coords,
        editable: false, draggable: false,
        strokeColor: color,
        content: name,
        clickable: false
      });
      
      if (this.infoWindow == null) {
        this.infoWindow = new google.maps.InfoWindow();
      }
      
      var vm = this;
      var map = this.map;
      
      var showArrays = function(event) {
        vm.infoWindow.setContent(name);
        vm.infoWindow.setPosition(event.latLng);
        vm.infoWindow.open(map);
      };
      
      // polygon.addListener("click", showArrays);
      
      polygon.setMap(map);
      
      console.log("Restored polygon");
      
      return polygon;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrapper {
  position: relative;
}
.state-summary {
  float: left;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
